import { z } from "zod";
/** Shared cursor-pagination query parameters for list endpoints. */
export const cursorQuerySchema = z.object({
    cursor: z.string().min(1).optional(),
    limit: z.coerce.number().int().positive().max(100).optional(),
});
export function createPaginatedResponseSchema(itemSchema) {
    return z.object({
        items: z.array(itemSchema),
        nextCursor: z.string().nullable(),
    });
}
//# sourceMappingURL=pagination.js.map